import React, { useState, useEffect } from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import { getPortfolioCategory } from '../../api'
import { Typography, Button } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import ice_machines_tube_flake from '../../Catalogues/ice_machines_tube_flake.pdf'
import ProductShowcase from './ProductShowcase'

const FEATURES = [
  'Fully automatic — one touch operation',
  'Graphic display of process and parameters',
  'Ice water in contact with SS304, cPVC only',
  'Control from smartphone or PC',
]

function Icemachine() {
  const [products, setProducts] = useState([])

  useEffect(() => {
    getPortfolioCategory('ice_machine').then(setProducts).catch(() => {})
  }, [])

  return (
    <>
      <Navbar />

      <main className='page-shell'>
        <div className='page-title-block'>
          <Typography className='page-title'>Tube Ice Machines</Typography>

          <div className='pp-features'>
            {FEATURES.map((f) => (
              <div className='pp-feature' key={f}>{f}</div>
            ))}
          </div>

          <div className='pp-cta-row'>
            <a href={ice_machines_tube_flake} download='celsius-ice-machine-tube-flake'>
              <Button className='pp-cta-btn' startIcon={<FileDownloadOutlinedIcon />}>
                Catalogue (PDF)
              </Button>
            </a>
          </div>
        </div>

        <div className='page-stack'>
          {products.map((p, i) => (
            <ProductShowcase
              key={i}
              title={p.specs.name}
              images={p.image_paths}
              specs={[
                { label: 'Location', value: p.specs.location },
                { label: 'Capacity', value: p.specs.capacity },
                { label: 'Compressor', value: p.specs.compressor },
                { label: 'Refrigerant', value: p.specs.refrigerant },
                { label: 'Controller', value: p.specs.controller },
              ]}
              badges={[
                p.specs.water_cooled_condenser && 'Water-cooled condenser',
                p.specs.remote && 'Smartphone / PC control',
              ]}
            />
          ))}
        </div>
      </main>

      <Footer />
    </>
  )
}

export default Icemachine
